<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_v"><span class="txit">To Clarence, for help when I needed it.</span></a><a id="page_vi"></a></p><a id="page_vi">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?511aeeeb